export default __webpack_public_path__ + "static/media/parrotSocialHero.12b71db6.png";